import {
  createClient,
  SupabaseClient
} from "@supabase/supabase-js";

export class SupabaseInstance {
  private static instance: SupabaseInstance;
  private supabase: SupabaseClient;

  private constructor() {
    this.supabase = createClient(
      import.meta.env.VITE_SUPABASE_URL,
      import.meta.env.VITE_SUPABASE_ANON_KEY,
      {
        realtime: {
          params: {
            eventsPerSecond: 5
          },
          heartbeatIntervalMs: 30000,
        }
      }
    );
  }

  // Singleton pattern ile tek instance garantisi
  public static getInstance(): SupabaseInstance {
    if (!SupabaseInstance.instance) {
      SupabaseInstance.instance = new SupabaseInstance();
    }
    return SupabaseInstance.instance;
  }

  // Supabase client'a erişim için getter
  public getClient(): SupabaseClient {
    return this.supabase;
  }
}

export const _supabaseClient = SupabaseInstance.getInstance().getClient();
  